import React from 'react';
import { FaAddressBook, FaPlus, FaSync } from 'react-icons/fa';
import { Col } from 'reactstrap'; // Jika menggunakan reactstrap atau layout grid lainnya
import { SettingGeneralProvider } from '../../../context/settingGeneralContext';
import HeaderReusable from '../../Global/HeaderContent';
import { FaWallet } from 'react-icons/fa';

export default function HeaderFee({
  isTabletOrMobile,
  title = "List Fee",
  query,
  setQuery,
  limit,
  setLimit,
  searchData,
  buttonRefresh,
  viewModalAdd
}) {
  return (
    <SettingGeneralProvider>
      <HeaderFeeContent
        isTabletOrMobile={isTabletOrMobile}
        title={title}
        query={query}
        setQuery={setQuery}
        limit={limit}
        setLimit={setLimit}
        viewModalAdd={viewModalAdd}
        buttonRefresh={buttonRefresh}
        searchData={searchData}
      />
    </SettingGeneralProvider>
  )
}

function HeaderFeeContent({
  isTabletOrMobile,
  title,
  query,
  setQuery,
  limit,
  setLimit,
  searchData,
  buttonRefresh,
  viewModalAdd
}) {
  return (
    <>
      <HeaderReusable
        title={title}
        icon={FaWallet}
        isTabletOrMobile={false}
        query={query}
        setQuery={setQuery}
        limit={limit}
        setLimit={setLimit}
        searchData={searchData}
        onAdd={viewModalAdd}
        showAddButton={true}
        onRefresh={buttonRefresh}
        showRefreshButton={true}
      />
    </>
  )
}
